import React, { ReactElement, useEffect, useRef, useState } from 'react';
import './VolumeTabBar.scss';
import KodanshaSelectMenu from '../../../../KodanshaUIKit/KodanshaSelectMenu/KodanshaSelectMenu';
import SortArrow from '../../../../Assets/icons/SortArrow';
import { ProductsForSeriesAtom, SingleSeriesAtom, SingleSeriesHasChaptersAtom } from '../../../../../store/SeriesStore';
import { useAtomValue } from 'jotai';

const VolumeTabBar = ({ setShowChapters, areThereFreeChapters, showChapters, volumeCount, volumes, sortVolumes, sorted }): ReactElement => {
    const [isCover, setIsCover] = useState(false);

    const tabBarRef = useRef(null);
    const initialOffsetTop = useRef(0);

    const scrollToItem = (number: number): void => {
        const itemRef = document.getElementById('volume-' + number.toString());
        const headerOffset = 200;
        const elementPosition = itemRef.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
        // itemRef?.scrollIntoView({ behavior: 'smooth' });
    };

    const onScrolled = (): void => {
        const offsetTop = tabBarRef.current?.getBoundingClientRect().top;
        if (offsetTop <= 94) {
            setIsCover(true);
        } else {
            setIsCover(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', onScrolled);
        initialOffsetTop.current = tabBarRef.current?.offsetTop;

        return (): void => {
            window.removeEventListener('scroll', onScrolled);
        };
    }, []);

    return (
        <div onScroll={onScrolled} ref={tabBarRef}
             className='series-tabs-desktop-container'>
            {isCover && <div className='series-tabs-desktop-cover' />}

            <div className='series-tabs-desktop-wrapper' style={{ borderBottom: isCover ? '1px solid black' : 'none' }}>
                <h2 className={'series-tabs-desktop-volumes-text'}>{volumeCount} Volumes</h2>
                <div className={'series-tabs-desktop-cascade-wrapper'}>
                    <KodanshaSelectMenu
                        onItemSelected={(index: number) => {
                            console.log('index', index);
                            scrollToItem(index);
                        }}
                        title={'jump to volume'} items={volumes?.map(item => item.volumeNumber ? item.volumeNumber : item.name)} />
                </div>

                <div className={`${sorted ? 'sort-icons-wrapper-active' : 'sort-icons-wrapper'}`}
                     onClick={sortVolumes}>
                    <SortArrow />
                    <SortArrow />
                </div>


                {areThereFreeChapters && <div onClick={() => setShowChapters(showChapters => !showChapters)}
                      className='series-tabs-desktop-chapters-show-wrapper'>
                    <div className='series-tabs-desktop-chapters-show-text'>
                        {showChapters ? 'HIDE' : 'SHOW'} CHAPTERS
                    </div>

                    <div className='series-tabs-desktop-chapters-show-plus'>
                        {showChapters ? '-' : '+'}
                    </div>
                </div>}

            </div>
        </div>
    );
};

export default React.memo(VolumeTabBar);